import { AfterViewInit, Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { ReplaySubject, Subject } from 'rxjs';
import { debounceTime, delay, map, takeUntil, tap } from 'rxjs/operators';
import { Api } from 'src/app/shared/constants/api';
import { KEYS } from 'src/app/shared/constants/keys';
import { IBase } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { LayoutService } from '../layout.service';

interface ICompany extends IBase{
   code:string,
   name:string,
   companyId:number,
   isCompanyDeactivated:string
}

interface IBranch extends IBase{
  code:string,
  name:string,
  branchId:number,
  isBranchDeactivated:string
}

@Component({
    selector: 'app-company-branch-selection',
    templateUrl: './company-branch-selection.component.html',
    styleUrls: ['./company-branch-selection.component.less'],
    standalone: false
})
export class CompanyBranchSelectionComponent implements OnInit,OnDestroy {

  constructor(private dailogRef:MatDialogRef<CompanyBranchSelectionComponent>,
              @Inject(MAT_DIALOG_DATA) public data:any,private formBuilder:FormBuilder,
              private service:DataService,private logger:NGXLogger,
              private router:Router,private layoutService:LayoutService) {
                  this.dailogRef.disableClose=true;
               }

  @Input() searching: boolean = false;
  onDestroy = new Subject<void>();
  companyList=[];
  branchList=[];
  companyBranchForm:FormGroup;
  role=localStorage.getItem(KEYS.ROLE); 
  filteredCompany:ReplaySubject<ICompany[]> = new ReplaySubject<ICompany[]>(1);
  filteredBranch:ReplaySubject<IBranch[]> = new ReplaySubject<IBranch[]>(1);  
  companyCtrl=this.formBuilder.control('');
  branchCtrl=this.formBuilder.control('');          

  ngOnInit(): void {
     this.initializeForm();
     this.setCompanyValueChangeEvent();
     this.setDefaultCompanyBranchValue();
     this.getCompanyList();
     this.filterCompany();
     this.filterBranch();
  }

  ngOnDestroy(){
    this.onDestroy.next();
    this.onDestroy.complete(); 
  }

  setDefaultCompanyBranchValue(){
      if(localStorage.getItem(KEYS.COMPANY_ID)){
        this.company=+localStorage.getItem(KEYS.COMPANY_ID);
      }
  }

  initializeForm(){
     this.companyBranchForm=this.formBuilder.group({
        companyId:[null],
        branchId:[null]
     });
  }

  setCompanyValueChangeEvent(){
    this.companyId.valueChanges.subscribe((companyId) => {
      this.logger.info('company changes',companyId);
      if(companyId){
        this.getBranchList(companyId);
      } 
    });
  }
  
  onCancel(){
    this.dailogRef.close();
  }

  onChange(){
     if(this.companyId.value){
       localStorage.setItem(KEYS.COMPANY_ID, this.companyId.value);
     } else {
       localStorage.removeItem(KEYS.COMPANY_ID);
       localStorage.removeItem(KEYS.BRANCH_ID);
     }
     if(this.branchId.value && this.companyId.value){
      localStorage.setItem(KEYS.BRANCH_ID, this.branchId.value);
     } else {
       localStorage.removeItem(KEYS.BRANCH_ID);
     }
     this.layoutService.companyBranchChanged.next('valueChanged');
     this.refreshPage();
  }

  private refreshPage() {
    this.logger.info("location", this.router.url);
    let currentUrl = this.router.url;
    this.router.navigateByUrl(".", { skipLocationChange: true });
    this.router
      .navigateByUrl("/dashboard", { skipLocationChange: false })
      .then(() => this.router.navigateByUrl(currentUrl));
    this.onCancel();
  }

  filterCompany() {
    this.companyCtrl.valueChanges.pipe(
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          this.logger.info('Company Search',search);
          if (!this.companyList) { return []; }
          if(!search) { this.filteredCompany.next(this.companyList); }
          this.logger.info('Filtered Company',this.companyList.filter(company => company.name.toLowerCase().indexOf(search) > -1));
          return this.companyList.filter(company => company.name.toLowerCase().indexOf(search.toLowerCase()) > -1);
        }),
        delay(200)
      )
      .subscribe(filteredCompany => {
        this.searching = false;
        this.filteredCompany.next(filteredCompany);
      },
      error => { this.searching = false; });
  }

  filterBranch() {
    this.branchCtrl.valueChanges.pipe(
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          this.logger.info('Branch Search',search);
          if (!this.branchList) { return []; }
          if(!search) { this.filteredBranch.next(this.branchList); }
          return this.branchList.filter(branch => branch.name.toLowerCase().indexOf(search) > -1);
        }),
        delay(200)
      )
      .subscribe(filteredBranch => {
        this.searching = false;
        this.filteredBranch.next(filteredBranch);
      },
      error => { this.searching = false; });
  }

  getCompanyList(){
    this.service.get(Api.USER_COMPANY_LIST).subscribe((res) => {
      if(res){
        this.companyList = res;
        this.logger.info('Company res',this.companyList);
        this.filteredCompany.next(this.companyList);
      }
    });
  }

  getBranchList(companyId) {
    this.logger.info('branch service Called');
    this.branchList = [];
    if (companyId === null || companyId === undefined) {
      return;
    }
    this.service.get(Api.USER_COMPANY_BRANCH_LIST+companyId).subscribe((res) => {
      this.logger.info("company Branch res", res);
      if(res){
        this.branchList=res;
        this.filteredBranch.next(this.branchList);
        if(localStorage.getItem(KEYS.BRANCH_ID)){
          this.branch=+localStorage.getItem(KEYS.BRANCH_ID);
       }
      }
    });
  }

  get companyId(){return this.companyBranchForm.get('companyId'); }
  get branchId(){return this.companyBranchForm.get('branchId'); }
  set company(companyId){ this.companyBranchForm.get('companyId').setValue(companyId);}
  set branch(branchId){ this.companyBranchForm.get('branchId').setValue(branchId);}
}
